export default __webpack_public_path__ + "static/media/ru-ta.494e19a3.svg";